import {
  ContentWrapper,
  InnerWrapper,
  SwitchWrapper,
  TabsWrapper,
  TopWrapper,
} from "./styled";
import { useSettings } from "../../context";
import NotSelectedView from "./not-selected";
import { useTimelineContext } from "../../remotion-timeline/context/use-timeline-context";
import Switch from "../../../../../../library/switch";
import TextSettings from "./text-settings";
import VideoSettings from "./video-settings";

const Configuration = () => {
  const { selectedItem } = useTimelineContext();
  const { applyToAll, setApplyToAllForCurrentItem, getSelectedItemSettings } =
    useSettings();

  const currentSettings = getSelectedItemSettings();

  const handleApplyToAllChange = () => {
    setApplyToAllForCurrentItem(!applyToAll);
  };

  const renderSelection = () => {
    switch (currentSettings?.type) {
      case "text":
        return <TextSettings />;
      case "video":
        return <VideoSettings />;
      default:
        return <div>Default Settings</div>;
    }
  };

  return (
    <ContentWrapper>
      {selectedItem ? (
        <InnerWrapper>
          <TopWrapper>
            <SwitchWrapper>
              <Switch
                checked={applyToAll}
                onChange={handleApplyToAllChange}
                label="Bruk på alle"
                size="small"
              />
            </SwitchWrapper>
          </TopWrapper>
          <TabsWrapper>{renderSelection()}</TabsWrapper>
        </InnerWrapper>
      ) : (
        <NotSelectedView />
      )}
    </ContentWrapper>
  );
};

export default Configuration;
